import React, { useState, useRef, useEffect } from 'react';
import PropTypes from 'prop-types';

import env from 'environment';
import useCollisionStyle from './useCollisionStyle';

const {
  PLATFORM_URL,
} = env;

const ComponentWrapper = ({ cssPaths, children }) => {
  useCollisionStyle(...cssPaths);

  return (
    <>
      {children}
    </>
  );
};

const useCollisionComponent = ({
  name,
  css: cssPaths,
  props = {},
}) => {
  const [data, setData] = useState({});

  useEffect(() => {
    (async () => {
      const {
        default: render,
        cleanUp,
      } = await fetch(`${PLATFORM_URL}/asset_path/${name}.js`)
        .then((response) => response.text())
        .then((code) => (0, eval)(code));

      setData({
        render,
        cleanUp,
      });
    })();
  }, [name]);

  const {
    render,
    cleanUp,
  } = data;

  const containerRef = useRef(null);

  useEffect(() => {
    if (containerRef.current && render) {
      render(containerRef.current, props);
    }

    return () => {
      if (cleanUp) {
        cleanUp(containerRef.current);
      }
    };
  }, [containerRef.current, render]);

  return (
    <ComponentWrapper cssPaths={cssPaths}>
      <div ref={containerRef} />
    </ComponentWrapper>
  );
};

useCollisionComponent.propTypes = {
  name: PropTypes.string.isRequired,
  css: PropTypes.string,
  props: PropTypes.object,
};

export default useCollisionComponent;



// WEBPACK FOOTER //
// ./app/utils/useCollisionComponent.js